import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// スクロールして画面エリアに入ったら要素を表示する lazydisp
import LAZYDISP from '../plugins/lazydisp';

// IE11でSVGの外部参照を有効にする
import 'svgxuse';

const [ w, d, l, mq ] = [ window, document, location, window.matchMedia('(min-width: 900px)') ];

const init = () => {
  d.documentElement.classList.remove('no-js');
  gsap.registerPlugin(ScrollTrigger);
}

const drawerMenu = () => {
  const $drawer = $('[data-plugin=drawer]'),
        $btn = $drawer.filter('[data-role="button"]'),
        $menu = $drawer.filter('[data-role="menu"]');
  $btn.on('click',function(){
    $btn.toggleClass('active');
    $menu.toggleClass('active');
  });
  $(d).on('click touchend', function(e) {
    if (!$(e.target).closest( $menu ).length && !$(e.target).closest( $btn ).length) {
      $btn.removeClass('active');
      $menu.removeClass('active');
    }
  });
}

const documentLoaded = () => {

  drawerMenu();

  // lazydisp
  LAZYDISP('[data-lazydisp]');

  ScrollTrigger.create({
    trigger: 'body', // 要素"body"がビューポートに入ったときにアニメーション開始
    start: 'top -=100%', // アニメーション開始位置
    markers: false, // マーカー表示
    onEnter() {
      $('.pagetop__wrap').removeClass('hidden')
    },
    onLeaveBack() {
      $('.pagetop__wrap').addClass('hidden')
    },
  });

  // 左下からふわっと表示
  const fadeElements = document.querySelectorAll('.fade-in-right-bottom');

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('active');
        observer.unobserve(entry.target); // 一度表示されたら監視を解除
      }
    });
  });

  fadeElements.forEach(element => {
    observer.observe(element);
  });

};

export default function INIT () {
  init();
  $(() => documentLoaded() );
}